export const methods = [
  {
    id: 2,
    name: "Exámenes conductores",
    description:
      "Ingreso de la información de las pruebas de alcoholimetría practicadas a los conductores.",
  },
];








export const breathalyzerGrade = [
      { id: 1, label: "1. Grado 0" },
      { id: 2, label: "2. Grado 1" },
      { id: 3, label: "3. Grado 2" },
      { id: 4, label: "4. Grado 3" },
]

export const medicalExams = [
      { id: 1, label: "1. SI" },
      { id: 2, label: "2. NO" },
]

export const breathalyzerDrivers = [
      { id: 1, label: "1. Positivo" },
      { id: 2, label: "2. Negativo" },
]

export const plateDestinations = [
      { id: 1, label: "1. Nacional" },
      { id: 2, label: "2. Internacional" },
    ]

export const areas = [
      { id: 1, label: "1. Basico - Corriente " },
      { id: 2, label: "2. Lujo" },
      { id: 3, label: "3. Corriente directo" },
]

export const getNameDepartamentOrigin = (_item, divipola) => {
  let name = "";

  for (const _code of divipola) {
    if (_code.cod_depto === _item.dptoOrigenRuta) {
      name = _code.dpto;
    }
  }

  return name ? name : _item.dptoOrigenRuta;
};

export const getNameMunicipalityOrigin = (_item, divipola) => {
  let name = "";
  const foundMunicipality = divipola.map(
    (_itemOrigin) => _itemOrigin.municipalities
  );

  foundMunicipality.forEach((x) => {
    x.forEach((y) => {
      if (y.cod_mpio === _item.municipioOrigenRuta) {
        name = y.nom_mpio;
      }
    });
  });

  return foundMunicipality ? name : _item.municipioOrigenRuta;
};

export const getNameDepartamentDestiny = (_item, divipola) => {
  let name = "";

  for (const _code of divipola) {
    if (_code.cod_depto === _item.dptoDestinoRuta) {
      name = _code.dpto;
    }
  }

  return name ? name : _item.dptoDestinoRuta;
};

export const getNameMunicipalityDestiny = (_item, divipola) => {
  let name = "";
  const foundMunicipality = divipola.map(
    (_itemOrigin) => _itemOrigin.municipalities
  );

  foundMunicipality.forEach((x) => {
    x.forEach((y) => {
      if (y.cod_mpio === _item.municipioDestinoRuta) {
        name = y.nom_mpio;
      }
    });
  });

  return foundMunicipality ? name : _item.municipioDestinoRuta;
};
